import { Alert, Badge, Col, Row, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import Loading from "../Loading";
import TabContainerWithTabs from "../components/TabContainer";
import { extractServerMessage } from "../lib/api";
import { securityPath } from "../lib/security";
import { STATUS_VARIANTS } from "./PositionSwap";
import RebalanceActionButtons from "./RebalanceActionButtons";
import RebalancesNav from "./RebalancesNav";
import { useQueryPositionSwaps } from "./positionSwapsLib";

/**
 * APP-1486 swap R77: the firm's position swaps, whatever their status, in the
 * order `GET /firm/position-swaps` answers them (the most recently updated
 * first), each linked to its swap screen.
 */
const PositionSwapsList = () => {
  const { data, isLoading, isError, error } = useQueryPositionSwaps();
  if (isLoading) return <Loading />;
  if (isError) {
    return (
      <Alert variant="danger">
        {extractServerMessage(error) ??
          "The position swaps could not be loaded."}
      </Alert>
    );
  }
  if (!data || data.length === 0) {
    return (
      <p className="text-secondary" data-testid="position-swaps">
        The firm has no position swap yet. Start one from the page of the
        security to move out of.
      </p>
    );
  }
  return (
    <Table data-testid="position-swaps">
      <thead>
        <tr>
          <th>Swap</th>
          <th>Security</th>
          <th>Replacement</th>
          <th>Status</th>
          <th className="text-end">Households</th>
          <th>Created by</th>
          <th>Last updated</th>
        </tr>
      </thead>
      <tbody>
        {data.map((swap) => (
          <tr key={swap.id}>
            <td>
              <Link to={`/rebalances/position-swaps/${swap.id}`}>
                {swap.name}
              </Link>
            </td>
            <td className="font-monospace">
              <Link to={securityPath(swap.symbol)}>{swap.symbol}</Link>
            </td>
            <td className="font-monospace">
              {swap.replacementSymbol ?? "Cash"}
            </td>
            <td>
              <Badge bg={STATUS_VARIANTS[swap.status]}>{swap.status}</Badge>
            </td>
            <td className="text-end">{swap.households}</td>
            <td>{swap.createdBy}</td>
            <td className="text-nowrap">
              {new Date(swap.updated).toLocaleString()}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

/** The "Position swaps" view of Trade Proposals. */
const PositionSwaps = () => (
  <>
    <Row>
      <Col>
        <RebalanceActionButtons />
      </Col>
    </Row>
    <TabContainerWithTabs tabs={RebalancesNav}>
      <PositionSwapsList />
    </TabContainerWithTabs>
  </>
);

export default PositionSwaps;
